export enum ButtonType {
  primary = 'primary',
  ghost = 'ghost',
  danger = 'danger',
  dashed = 'dashed',
  link = 'link',
  text = 'text',
}
